package music.jammers.client.shared.component.member.info.legend.di

import music.jammers.client.shared.component.member.info.legend.presentation.viewmodel.MemberInfoDialogViewModel
import music.jammers.client.shared.component.member.info.legend.presentation.viewmodel.MemberInfoLegendViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val memberInfoLegendModule = module {

    factory {
        MemberInfoLegendViewModel(
            router = get(),
        )
    }

    factory {
        MemberInfoDialogViewModel(
            router = get(),
        )
    }
}

class MemberInfoDIComponent : KoinComponent {

    val memberInfoLegendViewModel: MemberInfoLegendViewModel
        get() = getKoin().get<MemberInfoLegendViewModel>()

    val memberInfoDialogViewModel: MemberInfoDialogViewModel
        get() = getKoin().get<MemberInfoDialogViewModel>()
}